/* Rental price preview and availability request. Shopify's native contact form owns registration. */
(() => {
  let disposePricing = () => {};
  let editorReinitializing = false;
  const initialize = () => {
  disposePricing();
  const priceNode = typeof document === 'undefined' ? null : document.querySelector('[data-rental-price-config]');
  let rates = null;
  try {
    const candidate = JSON.parse(priceNode?.textContent || 'null');
    const groups = ['lightweight', 'softtop', 'hardtop', 'roofbars'];
    const extras = ['awning', 'powerbank', 'bikecarrier'];
    const validEuro = value => Number.isSafeInteger(value) && value > 0 && Number.isSafeInteger(value * 100);
    if (candidate?.currency === 'EUR' && typeof candidate.version === 'string' &&
        groups.every(key => ['1', '2', '3', '4', '5plus'].every(tier => validEuro(candidate.rates?.[key]?.[tier]))) &&
        extras.every(key => validEuro(candidate.rates?.[key]?.daily))) rates = candidate;
  } catch (_) { /* A missing tariff must stop the request, never become a free rental. */ }
  const lineTotalCents = (key, days) => {
    if (!rates || !Number.isSafeInteger(days) || days < 1 || !rates.rates[key]) throw new Error('Ongeldige huurprijsconfiguratie');
    const entry = rates.rates[key];
    const cents = entry.daily ? entry.daily * 100 * days : days < 5 ? entry[String(days)] * 100 : entry['5plus'] * 100 * days;
    if (!Number.isSafeInteger(cents)) throw new Error('Ongeldige huurprijsconfiguratie');
    return cents;
  };
  const lineTotal = (key, days) => lineTotalCents(key, days) / 100;
  const dailyRate = (key, days) => lineTotal(key, days) / days;
  const accessoryTotal = (days, selected) => selected.reduce((sum, key) => sum + lineTotal(key, days), 0);
  const duration = (start, end) => {
    if (!start || !end || end < start) return 0;
    const parse = (value) => value.split('-').map(Number);
    const [sy, sm, sd] = parse(start), [ey, em, ed] = parse(end);
    return Math.round((Date.UTC(ey, em - 1, ed) - Date.UTC(sy, sm - 1, sd)) / 86400000) + 1;
  };
  const buildWhatsappUrl = (base, message) => `${new URL(base).origin}${new URL(base).pathname}?text=${encodeURIComponent(message)}`;
  const humanDateRange = (start, end) => {
    const [sy, sm, sd] = start.split('-').map(Number), [ey, em, ed] = end.split('-').map(Number);
    const month = value => new Intl.DateTimeFormat('nl-NL', { month: 'short', timeZone: 'UTC' }).format(new Date(Date.UTC(2026, value - 1, 1))).replace('.', '');
    if (sy === ey && sm === em) return `${sd}–${ed} ${month(sm)} ${sy}`;
    if (sy === ey) return `${sd} ${month(sm)}–${ed} ${month(em)} ${sy}`;
    return `${sd} ${month(sm)} ${sy}–${ed} ${month(em)} ${ey}`;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { dailyRate, lineTotal, accessoryTotal, duration, buildWhatsappUrl, humanDateRange };
  if (typeof document === 'undefined') return;

  const root = document.querySelector('[data-rental-pricing]');
  if (!root || root.dataset.initialized === 'true') return;
  if (!rates) {
    root.querySelectorAll('button, input, select').forEach(control => { control.disabled = true; });
    const error = document.createElement('p');
    error.className = 'rental-pricing__config-error';
    error.setAttribute('role', 'alert');
    error.textContent = 'Huurprijzen zijn tijdelijk niet beschikbaar. Neem contact met ons op.';
    root.prepend(error);
    return;
  }
  const form = root.querySelector('#RentalAvailabilityForm');
  const backdrop = root.querySelector('[data-rental-modal-backdrop]');
  const dialog = root.querySelector('[data-rental-dialog]');
  const oldZone = document.querySelector('[data-rental-form-zone]');
  if (!form || !backdrop || !dialog) return;
  root.dataset.initialized = 'true';
  const controller = new AbortController();
  const resources = [];
  const listen = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal: controller.signal });
  const frame = callback => { const id = requestAnimationFrame(() => { if (!controller.signal.aborted) callback(); }); resources.push(() => cancelAnimationFrame(id)); return id; };
  const later = (callback, ms) => { const id = window.setTimeout(() => { if (!controller.signal.aborted) callback(); }, ms); resources.push(() => window.clearTimeout(id)); return id; };
  const animate = (target, frames, options) => { const animation = target.animate(frames, options); resources.push(() => animation.cancel()); return animation; };

  const cards = Object.fromEntries([...root.querySelectorAll('[data-price-card]')].map(card => [card.dataset.priceCard, card]));
  const startInput = form.querySelector('[data-rental-start]');
  const endInput = form.querySelector('[data-rental-end]');
  const vehicle = form.querySelector('[data-rental-vehicle]');
  const feedback = form.querySelector('[data-rental-feedback]');
  const retry = form.querySelector('[data-rental-retry]');
  const fallback = form.querySelector('[data-rental-fallback]');
  const submit = form.querySelector('[data-rental-submit]');
  const cta = root.querySelector('.rental-pricing__cta');
  const submissionCopy = JSON.parse(form.querySelector('[data-rental-submission-copy]').textContent);
  const fallbackLabel = fallback.textContent;
  const whatsappBase = new URL(fallback.href).origin + new URL(fallback.href).pathname;
  const storageKey = 'daktenterRentalAvailabilityPending';
  const handoffKey = 'daktenterRentalAvailabilityHandoff';
  const draftKey = 'daktenterRentalDraftV1';
  const readStorage = key => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const removeStorage = key => { try { sessionStorage.removeItem(key); } catch (_) { /* Storage may be disabled. */ } };
  const writeStorage = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) { /* Keep the live form usable. */ } };
  const state = { tent: '', roofbars: false, roofbarsAnswered: false, accessoryConfirmed: false, earlyAccessories: [], mobileStage: 'tent', transitionTarget: '', transitioning: false, modalStep: 'dates', previewDays: 1, month: new Date(), open: false, submitting: false, submissionPhase: 'idle', submissionDeadline: 0, reference: '', returnFocus: null, bodyOverflow: '', lastTotalEvent: '', vehicleCompleted: false, carouselViewed: false };
  const funnel = root.querySelector('[data-mobile-funnel]');
  const carousel = root.querySelector('[data-rental-tent-carousel]');
  const roofStage = root.querySelector('[data-mobile-roof-stage]');
  const accessoryStage = root.querySelector('[data-rental-accessory-stage]');
  const accessoryKeys = ['awning', 'powerbank', 'bikecarrier'];
  const tentSummary = root.querySelector('[data-mobile-tent-summary]');
  // The same guided rental controller now owns both mobile and desktop.
  const isMobile = () => true;
  const desktopView = () => window.matchMedia('(min-width: 750px)').matches;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollTo = element => { element.scrollIntoView({ behavior: reduceMotion() ? 'instant' : 'smooth', block: 'start' }); };
  let restoring = false;
  let draftReady = false;
  let draftWorking = false;
  let preModalOffset = 72;
  let saveTimer = 0;
  let queueDraftSave = () => {};
  const sidebar = document.querySelector('[data-rental-desktop-sidebar]');
  const sidebarRail = sidebar && document.createElement('div');
  if (sidebarRail) {
    sidebarRail.className = 'rental-desktop-rail';
    const origin = document.createComment('rental-sidebar-origin'); sidebar.before(origin);
    resources.push(() => { if (origin.isConnected) origin.replaceWith(sidebar); sidebarRail.remove(); });
    sidebarRail.append(sidebar);
    document.body.append(sidebarRail);
  }
  const positionSidebarRail = () => {
    if (!sidebarRail) return;
    const intro = document.querySelector('#MainContent > [id$="__main"] .product-details');
    const header = document.querySelector('header-component');
    const gallery = document.querySelector('#MainContent > [id$="__main"] media-gallery');
    if (!intro || !header) return;
    const introTop = intro.getBoundingClientRect().top + window.scrollY;
    const galleryBottom = gallery ? gallery.getBoundingClientRect().bottom + window.scrollY : introTop;
    const top = galleryBottom + 28;
    const contentBottom = document.querySelector('#MainContent').getBoundingClientRect().bottom + window.scrollY;
    document.documentElement.style.setProperty('--rental-live-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    sidebarRail.style.top = `${top}px`;
    sidebarRail.style.height = `${Math.max(0, contentBottom - top)}px`;
    document.body.classList.toggle('rental-desktop-active', desktopView());
  };
  const scheduleRailPosition = () => frame(positionSidebarRail);
  scheduleRailPosition();
  listen(window, 'load', scheduleRailPosition, { once: true });
  if (sidebarRail && 'ResizeObserver' in window) {
    const railObserver = new ResizeObserver(scheduleRailPosition);
    railObserver.observe(document.querySelector('#MainContent'));
    resources.push(() => railObserver.disconnect());
  }
  state.month.setDate(1);
  const euro = amount => `€${amount}`;
  const dayLabel = days => `${days} ${days === 1 ? 'dag' : 'dagen'}`;
  const shortDate = value => value ? new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(`${value}T12:00:00`)) : 'Kies datum';
  const publish = (name, values = {}) => {
    if (restoring || window.Shopify?.designMode) return;
    const payload = { page_type: 'national_rental', source_section: 'pricing', ...values };
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (error) { console.warn('Rental event failed', error); }
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...payload });
    document.dispatchEvent(new CustomEvent('daktenter:rental-event', { detail: { name, parameters: payload } }));
  };
  const tentNames = { lightweight: 'Lichtgewicht daktent', softtop: 'Softtop daktent', hardtop: 'Hardtop daktent' };
  const shortTentNames = { lightweight: 'Lightweight', softtop: 'Softtop', hardtop: 'Hardtop' };
  const accessoryNames = { awning: 'Luifel', powerbank: 'Powerbank 20.000 mAh', bikecarrier: 'Fietsendrager voor 2 fietsen' };
  const selectedAccessories = () => [...cards.accessories.querySelectorAll('[data-preview-accessory]:checked')].map(input => input.value);
  const currentDays = () => duration(startInput.value, endInput.value) || (isMobile() ? 0 : state.previewDays);
  const lines = days => {
    const selected = [];
    if (state.tent) selected.push([shortTentNames[state.tent], lineTotal(state.tent, days)]);
    if (state.roofbars) selected.push(['Dakdragers', lineTotal('roofbars', days)]);
    if (selectedAccessories().includes('awning')) selected.push(['Luifel', lineTotal('awning', days), 'awning']);
    if (selectedAccessories().includes('powerbank')) selected.push(['Powerbank 20.000 mAh', lineTotal('powerbank', days), 'powerbank']);
    if (selectedAccessories().includes('bikecarrier')) selected.push(['Fietsendrager voor 2 fietsen', lineTotal('bikecarrier', days), 'bikecarrier']);
    return selected;
  };
  const total = days => lines(days).reduce((sum, [, price]) => sum + price, 0);
  const accessoryRemoveButton = key => {
    const button = document.createElement('button');
    button.type = 'button'; button.dataset.rentalRemoveAccessory = key;
    button.className = 'rental-pricing__remove-accessory';
    button.textContent = 'Verwijderen';
    button.setAttribute('aria-label', `${accessoryNames[key]} verwijderen`);
    return button;
  };
  const renderDesktopSidebar = () => {
    if (!sidebar) return;
    const committed = Boolean(state.tent && state.mobileStage !== 'tent');
    const tentRow = sidebar.querySelector('[data-rental-sidebar-tent]');
    const roofRow = sidebar.querySelector('[data-rental-sidebar-roof]');
    const datesRow = sidebar.querySelector('[data-rental-sidebar-dates]');
    const totalRow = sidebar.querySelector('[data-rental-sidebar-total]');
    const days = duration(startInput.value, endInput.value);
    sidebar.querySelector('[data-rental-sidebar-rate]').textContent = `Vanaf ${euro(rates.rates[committed ? state.tent : 'lightweight']['5plus'])} / dag`;
    sidebar.querySelector('[data-rental-sidebar-state]').textContent = !committed ? 'Kies eerst je daktent' : !state.roofbarsAnswered ? 'Kies of je dakdragers nodig hebt' : days ? 'Je reis in het kort' : 'Kies je reisdata';
    tentRow.hidden = !committed;
    roofRow.hidden = !committed || !state.roofbarsAnswered;
    datesRow.hidden = !days || !committed;
    totalRow.hidden = !days || !committed;
    if (committed) {
      const thumbnail = sidebar.querySelector('[data-rental-sidebar-thumbnail]');
      const original = cards[state.tent].querySelector('.rental-pricing__media img');
      if (original && thumbnail.dataset.tent !== state.tent) {
        const image = original.cloneNode(false);
        image.removeAttribute('loading');
        image.alt = '';
        thumbnail.replaceChildren(image);
        thumbnail.dataset.tent = state.tent;
      }
      sidebar.querySelector('[data-rental-sidebar-tent-name]').textContent = tentNames[state.tent];
      sidebar.querySelector('[data-rental-sidebar-roof-name]').textContent = state.roofbars ? 'Dakdragers gehuurd' : 'Eigen dakdragers';
      const roofThumbnail = sidebar.querySelector('[data-rental-sidebar-roof-thumbnail]');
      roofThumbnail.hidden = !state.roofbars;
      if (state.roofbars && !roofThumbnail.firstElementChild) {
        const roofImage = roofStage.querySelector('.rental-pricing__mobile-roofbars-media img')?.cloneNode(false);
        if (roofImage) { roofImage.alt = ''; roofImage.removeAttribute('loading'); roofThumbnail.append(roofImage); }
      }
    }
    const accessoryRows = sidebar.querySelector('[data-rental-sidebar-accessories]');
    if (accessoryRows) accessoryRows.replaceChildren(...(committed ? selectedAccessories() : []).map(key => {
      const row = document.createElement('div'); row.className = 'rental-desktop-sidebar__item';
      const name = document.createElement('span'); name.className = 'rental-desktop-sidebar__item-copy';
      name.textContent = accessoryNames[key];
      row.append(name, accessoryRemoveButton(key)); return row;
    }));
    if (days && committed) {
      datesRow.textContent = `${humanDateRange(startInput.value, endInput.value)} · ${dayLabel(days)}`;
      sidebar.querySelector('[data-rental-sidebar-total-value]').textContent = euro(total(days));
    }
  };
  const placeDesktopRoofCard = () => {
    const active = desktopView() && state.mobileStage === 'roofbars' && Boolean(state.tent);
    if (!active) {
      if (roofStage.parentElement === carousel) funnel.insertBefore(roofStage, root.querySelector('[data-mobile-roof-summary]'));
      roofStage.style.left = roofStage.style.top = roofStage.style.width = roofStage.style.height = '';
      return;
    }
    if (roofStage.parentElement !== carousel) carousel.append(roofStage);
    const chosen = cards[state.tent];
    // On narrow desktops the tent group becomes a horizontal carousel. Keep
    // the chosen slot inside its reserved column before placing the roof step;
    // otherwise the third card can sit beneath the sticky summary rail.
    if (carousel.scrollWidth > carousel.clientWidth) {
      const track = carousel.getBoundingClientRect();
      const slot = chosen.getBoundingClientRect();
      const delta = slot.right > track.right ? slot.right - track.right
        : slot.left < track.left ? slot.left - track.left : 0;
      if (Math.abs(delta) > 1) carousel.scrollLeft += delta;
    }
    roofStage.style.left = `${chosen.offsetLeft}px`;
    roofStage.style.top = `${chosen.offsetTop}px`;
    roofStage.style.width = `${chosen.offsetWidth}px`;
    roofStage.style.height = `${chosen.offsetHeight}px`;
  };
  // A responsive resize can move the three card slots after the resize event
  // (font and grid layout settle in the next frame). Keep the replacement card
  // attached to its selected slot, including mobile-to-desktop transitions.
  if ('ResizeObserver' in window) {
    const roofSlotObserver = new ResizeObserver(() => {
      if (desktopView() && state.mobileStage === 'roofbars') placeDesktopRoofCard();
    });
    resources.push(() => roofSlotObserver.disconnect());
    roofSlotObserver.observe(carousel);
    Object.values(cards).filter(card => card.dataset.priceCard !== 'roofbars' && card.dataset.priceCard !== 'accessories')
      .forEach(card => roofSlotObserver.observe(card));
  }
  const renderSummary = () => {
    const days = currentDays();
    const actual = duration(startInput.value, endInput.value);
    form.querySelector('[data-rental-start-label]').textContent = shortDate(startInput.value);
    form.querySelector('[data-rental-end-label]').textContent = shortDate(endInput.value);
    const display = form.querySelector('[data-rental-summary-lines]');
    display.replaceChildren(...(actual || !isMobile() ? lines(days) : []).map(([label, price]) => {
      const row = document.createElement('p');
      const name = document.createElement('span'); name.textContent = label;
      const amount = document.createElement('strong'); amount.textContent = euro(price);
      row.append(name, amount);
      return row;
    }));
    const finalLines = form.querySelector('[data-rental-final-lines]');
    finalLines.replaceChildren(...(actual ? lines(actual) : []).map(([label, price, key]) => {
      const row = document.createElement('p');
      const name = document.createElement('span'); name.textContent = label;
      const amount = document.createElement('strong'); amount.textContent = euro(price);
      row.append(name, amount);
      if (key) row.append(accessoryRemoveButton(key));
      return row;
    }));
    form.querySelectorAll('[data-accessory-line]').forEach(label => {
      label.textContent = actual ? `${dayLabel(actual)} · ${euro(lineTotal(label.dataset.accessoryLine, actual))}` : 'Kies je reisdata';
    });
    form.querySelector('[data-rental-modal-total]').textContent = actual || !isMobile() ? euro(total(days)) : '—';
    form.querySelector('[data-rental-extras-total]').textContent = actual || !isMobile() ? euro(total(days)) : '—';
    form.querySelector('[data-rental-range-label]').textContent = actual
      ? `${new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long' }).format(new Date(`${startInput.value}T12:00:00`))} – ${new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(`${endInput.value}T12:00:00`))} · ${dayLabel(actual)}`
      : 'Kies je reisdata';
    form.querySelector('[data-rental-review-tent]').textContent = tentNames[state.tent] || 'Nog geen daktent';
    form.querySelector('[data-rental-review-dates]').textContent = actual ? `${humanDateRange(startInput.value, endInput.value)} · ${dayLabel(actual)}` : 'Kies je reisdata';
    form.querySelector('[data-rental-review-options]').textContent = [state.roofbars ? 'Dakdragers' : 'Eigen dakdragers', ...selectedAccessories().map(item => accessoryNames[item])].join(' · ');
    const fulfilment = form.querySelector('[name="contact[Vertrek]"]:checked')?.value;
    form.querySelector('[data-rental-review-fulfilment]').textContent = fulfilment === 'Bezorging' ? 'Installatie bij jou thuis (vanaf €50)' : fulfilment ? `Ophalen in ${fulfilment}` : 'Kies bij jouw gegevens';
    form.querySelector('[data-rental-service-note]').hidden = fulfilment !== 'Bezorging';
    accessoryStage.querySelectorAll('[data-accessory-stage-total]').forEach(label => { label.hidden = !actual; label.textContent = actual ? `${dayLabel(actual)} · ${euro(lineTotal(label.dataset.accessoryStageTotal, actual))}` : ''; });
    document.dispatchEvent(new CustomEvent('daktenter:rental-state', { detail: { tent: state.tent, days: state.tent ? actual : 0, total: state.tent && actual ? total(actual) : null, startingRate: rates.rates[state.tent || 'lightweight']['5plus'] } }));
    renderDesktopSidebar();
    updateVehicle();
    queueDraftSave();
  };
  const render = () => {
    for (const [key, card] of Object.entries(cards)) {
      card.dataset.previewDays = String(state.previewDays);
      if (key !== 'accessories') {
        const selected = key === state.tent || (key === 'roofbars' && state.roofbars);
        card.dataset.selected = String(selected);
        card.querySelector('[data-preview-select]').setAttribute('aria-pressed', String(selected));
      }
      const value = card.querySelector('[data-preview-day-value]');
      if (value) { value.value = String(state.previewDays); value.textContent = String(state.previewDays); }
      const unit = card.querySelector('[data-preview-day-unit]');
      if (unit) unit.textContent = state.previewDays === 1 ? 'dag' : 'dagen';
      card.querySelector('[data-price-line]').textContent = key === 'accessories'
        ? (selectedAccessories().length ? `${dayLabel(state.previewDays)} = ${euro(accessoryTotal(state.previewDays, selectedAccessories()))}` : 'Kies een extra')
        : `${dayLabel(state.previewDays)} = ${euro(lineTotal(key, state.previewDays))}`;
    }
    root.querySelector('[data-rental-combined-total]').textContent = euro(total(state.previewDays));
    cta.disabled = !state.tent && !isMobile();
    root.querySelector('[data-rental-guidance]').hidden = Boolean(state.tent);
    form.querySelector('[data-rental-no-extras]').textContent = selectedAccessories().length ? "GEEN EXTRA'S TOEVOEGEN" : "GEEN EXTRA'S";
    accessoryStage.querySelectorAll('[data-rental-accessory-toggle]').forEach(button => { const selected = selectedAccessories().includes(button.dataset.rentalAccessoryToggle); button.setAttribute('aria-pressed', String(selected)); button.textContent = selected ? 'VERWIJDEREN' : 'TOEVOEGEN'; button.closest('[data-accessory-card]').dataset.selected = String(selected); });
    form.querySelectorAll('[data-modal-accessory]').forEach(input => { input.checked = selectedAccessories().includes(input.value); input.closest('label').hidden = selectedAccessories().includes(input.value); });
    const remainingOffers = accessoryKeys.filter(key => !selectedAccessories().includes(key));
    form.querySelector('[data-rental-no-extras]').hidden = !remainingOffers.length;
    form.querySelector('[data-rental-extras-intro]').hidden = !remainingOffers.length;
    renderSummary();
    const totalPayload = { tent_type: state.tent || 'none', days: state.previewDays, roof_bars: state.roofbars, awning: selectedAccessories().includes('awning'), powerbank: selectedAccessories().includes('powerbank'), bikecarrier: selectedAccessories().includes('bikecarrier'), total: total(state.previewDays) };
    const signature = JSON.stringify(totalPayload);
    if (signature !== state.lastTotalEvent) { publish('rental_preview_total_updated', totalPayload); state.lastTotalEvent = signature; }
    document.querySelectorAll('[data-rental-open]').forEach(button => { button.disabled = !state.tent && !isMobile(); });
    root.dataset.mobileTentSelected = String(Boolean(state.tent));
    root.dataset.mobileStage = state.mobileStage;
    carousel.hidden = isMobile() && state.mobileStage !== 'tent';
    accessoryStage.hidden = state.mobileStage !== 'accessories';
    roofStage.hidden = !isMobile() || state.mobileStage !== 'roofbars';
    root.querySelector('[data-mobile-roof-summary]').hidden = !isMobile() || !['calendar', 'accessories'].includes(state.mobileStage);
    root.querySelector('[data-mobile-roof-summary-text]').textContent = state.roofbars ? 'DAKDRAGERS TOEGEVOEGD' : 'EIGEN DAKDRAGERS';
    tentSummary.hidden = !isMobile() || !state.tent || state.mobileStage === 'tent';
    root.querySelector('[data-mobile-tent-name]').textContent = tentNames[state.tent]?.toUpperCase() || '';
    tentSummary.querySelectorAll('[data-mobile-summary-image]').forEach(image => { image.hidden = image.dataset.mobileSummaryImage !== state.tent; });
    form.querySelector('[data-rental-chosen-tent]').textContent = state.tent ? `${shortTentNames[state.tent]} · ${state.roofbars ? 'Dakdragers gehuurd' : isMobile() && state.roofbarsAnswered ? 'Eigen dakdragers' : 'Dakdragers niet bij de huur'}` : '';
    roofStage.querySelectorAll('[data-mobile-roofbars-answer]').forEach(button => button.setAttribute('aria-pressed', String(state.roofbarsAnswered && (button.dataset.mobileRoofbarsAnswer === 'yes') === state.roofbars)));
    form.querySelector('[data-rental-extras-total]').textContent = duration(startInput.value, endInput.value) || !isMobile() ? euro(total(currentDays())) : '—';
    root.dataset.desktopStage = desktopView() ? state.mobileStage : '';
    root.dataset.desktopTent = desktopView() ? state.tent : '';
    if (desktopView()) {
      carousel.hidden = state.mobileStage === 'accessories';
      roofStage.hidden = state.mobileStage !== 'roofbars';
      tentSummary.hidden = true;
      root.querySelector('[data-mobile-roof-summary]').hidden = true;
    }
    placeDesktopRoofCard();
    renderDesktopSidebar();
    queueDraftSave();
  };
  const switchMobileStage = (next, focusTarget) => {
    if (!isMobile() || state.transitioning) return;
    if (state.mobileStage === next) { focusTarget?.focus({ preventScroll: true }); return; }
    const announce = () => { root.querySelector('[data-mobile-step-status]').textContent = next === 'roofbars' ? 'Stap 2: kies dakdragers.' : 'Stap 1: kies je daktent.'; };
    if (reduceMotion() || window.matchMedia('(min-width: 750px)').matches) { state.mobileStage = next; state.transitionTarget = ''; render(); focusTarget?.focus({ preventScroll: true }); announce(); return; }
    state.transitioning = true;
    state.transitionTarget = next;
    const fromHeight = funnel.getBoundingClientRect().height;
    const source = next === 'roofbars' ? cards[state.tent] : tentSummary;
    const sourceRect = source.getBoundingClientRect();
    const funnelRect = funnel.getBoundingClientRect();
    let expandedCardSize;
    if (next === 'tent') {
      carousel.hidden = false;
      carousel.style.position = 'absolute';
      carousel.style.visibility = 'hidden';
      carousel.style.width = `${funnel.clientWidth}px`;
      const rect = cards[state.tent].getBoundingClientRect();
      expandedCardSize = { width: rect.width, height: rect.height };
      carousel.hidden = true;
      carousel.style.position = ''; carousel.style.visibility = ''; carousel.style.width = '';
    }
    const ghost = cards[state.tent].cloneNode(true);
    ghost.classList.add('rental-pricing__morph-ghost');
    ghost.setAttribute('aria-hidden', 'true');
    ghost.inert = true;
    ghost.style.top = `${sourceRect.top - funnelRect.top}px`;
    ghost.style.left = `${sourceRect.left - funnelRect.left}px`;
    ghost.style.width = `${sourceRect.width}px`;
    ghost.style.height = `${sourceRect.height}px`;
    const ghostSummary = tentSummary.cloneNode(true);
    ghostSummary.hidden = false;
    ghostSummary.classList.add('rental-pricing__mobile-summary--ghost');
    ghostSummary.querySelectorAll('[data-mobile-summary-image]').forEach(image => { image.hidden = image.dataset.mobileSummaryImage !== state.tent; });
    ghostSummary.querySelector('button').tabIndex = -1;
    ghost.append(ghostSummary);
    const morphLayer = document.createElement('div');
    morphLayer.className = 'rental-pricing__tent-group rental-pricing__morph-layer';
    morphLayer.setAttribute('aria-hidden', 'true');
    morphLayer.inert = true;
    morphLayer.append(ghost);
    funnel.append(morphLayer);
    funnel.style.height = `${fromHeight}px`;
    const content = [...ghost.children].filter(child => child !== ghostSummary);
    const showSummary = next === 'roofbars';
    ghostSummary.style.opacity = showSummary ? '0' : '1';
    content.forEach(child => { child.style.transition = showSummary ? 'opacity 250ms ease' : 'opacity 260ms ease 150ms'; child.style.opacity = showSummary ? '1' : '0'; });
    source.style.opacity = '0';
    if (showSummary) {
      carousel.classList.add('rental-pricing__tent-group--morphing');
      roofStage.hidden = false;
      roofStage.style.position = 'absolute';
      roofStage.style.top = '5.55rem';
      roofStage.style.width = '100%';
      roofStage.style.opacity = '0';
      roofStage.style.transition = 'opacity 150ms ease 300ms';
    }
    else roofStage.style.opacity = '0';
    frame(() => {
      ghost.style.transition = 'height 420ms cubic-bezier(.22,.8,.28,1), width 420ms cubic-bezier(.22,.8,.28,1)';
      ghostSummary.style.transition = showSummary ? 'opacity 280ms ease 130ms' : 'opacity 150ms ease';
      const targetWidth = showSummary ? funnel.clientWidth : expandedCardSize.width;
      const targetHeight = showSummary ? 78 : expandedCardSize.height;
      ghost.style.width = `${targetWidth}px`;
      ghost.style.height = `${targetHeight}px`;
      content.forEach(child => { child.style.opacity = showSummary ? '0' : '1'; });
      ghostSummary.style.opacity = showSummary ? '1' : '0';
      if (showSummary) roofStage.style.opacity = '1';
    });
    later(() => {
      state.mobileStage = next;
      render();
      carousel.classList.remove('rental-pricing__tent-group--morphing');
      source.style.opacity = '';
      roofStage.style.position = ''; roofStage.style.top = ''; roofStage.style.width = '';
      roofStage.style.transition = '';
      roofStage.style.opacity = showSummary ? '1' : '0';
      const toHeight = (() => { funnel.style.height = 'auto'; return funnel.getBoundingClientRect().height; })();
      funnel.style.height = `${fromHeight}px`;
      morphLayer.remove();
      if (next === 'tent') carousel.style.opacity = '0';
      frame(() => {
        funnel.style.height = `${toHeight}px`;
        roofStage.style.transition = 'opacity 260ms ease';
        roofStage.style.opacity = next === 'roofbars' ? '1' : '';
        if (next === 'tent') { carousel.style.transition = 'opacity 260ms ease'; carousel.style.opacity = '1'; }
      });
      later(() => {
        funnel.style.height = '';
        roofStage.style.opacity = ''; roofStage.style.transition = '';
        carousel.style.opacity = ''; carousel.style.transition = '';
        state.transitioning = false;
        state.transitionTarget = '';
        focusTarget?.focus({ preventScroll: true }); announce();
      }, 280);
    }, 440);
  };
  const updateVehicle = () => {
    vehicle.hidden = false;
    vehicle.disabled = false;
    vehicle.querySelectorAll('[data-rental-vehicle-field]').forEach(input => { input.required = true; });
  };
  // One lifecycle owns permission to enter Shopify's native CAPTCHA pipeline.
  // An elapsed UI deadline cannot tell us whether a provider/native POST completed.
  const submissionBlocked = () => ['pending', 'uncertain', 'confirmed'].includes(state.submissionPhase);
  const saveSubmissionOutcome = () => {
    try {
      const pending = JSON.parse(readStorage(storageKey) || 'null');
      if (!pending || pending.reference !== state.reference) return;
      pending.submissionPhase = state.submissionPhase;
      pending.submissionDeadline = state.submissionDeadline;
      // Keep only non-personal attempt metadata beyond the existing ten-minute TTL.
      // Expiry must not authorize another attempt with an unresolved reference.
      const record = Date.now() - pending.savedAt >= 600000
        ? { reference: pending.reference, savedAt: pending.savedAt, submissionPhase: pending.submissionPhase, submissionDeadline: pending.submissionDeadline }
        : pending;
      writeStorage(storageKey, JSON.stringify(record));
    } catch (_) { /* The in-memory guard still protects the current interface. */ }
  };
  const showSubmissionRecovery = () => {
    if (state.submissionPhase !== 'uncertain') return;
    state.submitting = false;
    submit.disabled = true; submit.hidden = true;
    submit.removeAttribute('aria-busy');
    feedback.classList.remove('is-registering');
    feedback.textContent = submissionCopy.uncertain;
    feedback.hidden = false; retry.hidden = true;
    fallback.hidden = false; fallback.textContent = submissionCopy.uncertain_action;
    fallback.href = buildWhatsappUrl(whatsappBase, `${submissionCopy.uncertain_message} ${state.reference}`);
  };
  const markSubmissionUncertain = () => {
    if (state.submissionPhase !== 'pending') return;
    state.submissionPhase = 'uncertain';
    saveSubmissionOutcome(); showSubmissionRecovery(); queueDraftSave();
  };
  const checkSubmissionDeadline = () => {
    if (state.submissionPhase === 'pending' && Date.now() >= state.submissionDeadline) markSubmissionUncertain();
    else showSubmissionRecovery();
  };
  listen(document, 'visibilitychange', checkSubmissionDeadline);
  listen(window, 'pageshow', checkSubmissionDeadline);
  const setError = message => {
    // Local validation and unknown provider/network outcomes cannot unlock a POST.
    if (submissionBlocked()) { markSubmissionUncertain(); showSubmissionRecovery(); return; }
    state.submitting = false;
    submit.disabled = false; submit.hidden = false;
    submit.removeAttribute('aria-busy');
    feedback.classList.remove('is-registering');
    feedback.textContent = message;
    feedback.hidden = false;
    retry.hidden = state.submissionPhase !== 'failed';
    fallback.hidden = false; fallback.textContent = fallbackLabel;
    fallback.href = whatsappUrl();
    publish('rental_request_error', { tent_type: state.tent || 'none' });
  };
  const resetError = () => {
    feedback.hidden = true; feedback.classList.remove('is-registering'); retry.hidden = true; fallback.hidden = true;
    showSubmissionRecovery();
  };
  const createReference = () => {
    const now = new Date();
    const date = `${String(now.getFullYear()).slice(-2)}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
    const random = window.crypto?.getRandomValues ? window.crypto.getRandomValues(new Uint32Array(1))[0] % 10000 : Math.floor(Math.random() * 10000);
    return `DR-${date}-${String(random).padStart(4, '0')}`;
  };
  const whatsappMessage = () => {
    const days = currentDays();
    const dateLabel = startInput.value && endInput.value ? `${humanDateRange(startInput.value, endInput.value)} (${dayLabel(days)})` : dayLabel(days);
    const items = lines(days).map(([label]) => label === 'Powerbank 20.000 mAh' ? 'Powerbank 20K mAh' : label);
    const fulfilment = form.querySelector('[name="contact[Vertrek]"]:checked')?.value || 'nog te kiezen';
    const vehicleText = `Auto: ${['Automerk', 'Automodel', 'Bouwjaar', 'Kenteken'].map(key => form.querySelector(`[name="contact[${key}]"]`)?.value.trim()).filter(Boolean).join(', ')}`;
    const note = form.querySelector('[data-rental-message]').value.trim();
    const details = [vehicleText, fulfilment === 'Bezorging' ? 'Installatie bij jou thuis' : `Ophalen: ${fulfilment}`].filter(Boolean).join('\n');
    return ['Hoi DAKTENTER!', `Ik wil graag beschikbaarheid controleren voor:\n${dateLabel}`, items.join('\n'), details, `Prijsindicatie: ${euro(total(days))}`, note ? `Opmerking: ${note.slice(0, 160)}` : '', `_Ref: ${state.reference || createReference()}_`].filter(Boolean).join('\n\n');
  };
  const whatsappUrl = () => buildWhatsappUrl(whatsappBase, whatsappMessage());
  const setHidden = (selector, value) => { form.querySelector(selector).value = String(value); };
  const fillSubmission = () => {
    const days = duration(startInput.value, endInput.value);
    setHidden('[data-rental-reference]', state.reference);
    setHidden('[data-rental-timestamp]', new Date().toISOString());
    setHidden('[data-rental-duration]', dayLabel(days));
    setHidden('[data-rental-price]', euro(total(days)));
    setHidden('[data-rental-tent]', shortTentNames[state.tent]);
    setHidden('[data-rental-tent-price]', euro(lineTotal(state.tent, days)));
    setHidden('[data-rental-roofbars]', state.roofbars ? 'Ja' : 'Nee');
    setHidden('[data-rental-roofbars-price]', state.roofbars ? euro(lineTotal('roofbars', days)) : euro(0));
    setHidden('[data-rental-awning]', selectedAccessories().includes('awning') ? 'Ja' : 'Nee');
    setHidden('[data-rental-awning-price]', selectedAccessories().includes('awning') ? euro(lineTotal('awning', days)) : euro(0));
    setHidden('[data-rental-powerbank]', selectedAccessories().includes('powerbank') ? 'Ja' : 'Nee');
    setHidden('[data-rental-powerbank-price]', selectedAccessories().includes('powerbank') ? euro(lineTotal('powerbank', days)) : euro(0));
    setHidden('[data-rental-bikecarrier]', selectedAccessories().includes('bikecarrier') ? 'Ja' : 'Nee');
    setHidden('[data-rental-bikecarrier-price]', selectedAccessories().includes('bikecarrier') ? euro(lineTotal('bikecarrier', days)) : euro(0));
    const detailed = lines(days).map(([name, amount]) => `${name}: ${euro(amount)}`).join('; ');
    const note = form.querySelector('[data-rental-message]').value.trim();
    setHidden('[data-rental-body]', `Ref: ${state.reference}\nPrijsconfiguratie: ${rates.version}\nReis: ${startInput.value} t/m ${endInput.value} (${dayLabel(days)})\n${detailed}\nTotaal prijsindicatie: ${euro(total(days))}\nVertrek: ${form.querySelector('[name="contact[Vertrek]"]:checked')?.value || ''}\nAuto: ${['Automerk', 'Automodel', 'Bouwjaar', 'Kenteken'].map(key => form.querySelector(`[name="contact[${key}]"]`)?.value.trim()).join(', ')}${note ? `\nOpmerking: ${note}` : ''}`);
  };
  const persistPending = () => {
    try { sessionStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), reference: state.reference, submissionPhase: state.submissionPhase, submissionDeadline: state.submissionDeadline, tent: state.tent, roofbars: state.roofbars, roofbarsAnswered: state.roofbarsAnswered, previewDays: state.previewDays, accessories: selectedAccessories(), fields: Object.fromEntries([...form.querySelectorAll('input:not([type="hidden"]), textarea')].filter(input => (input.name || input.hasAttribute('data-rental-message')) && (input.type !== 'radio' || input.checked)).map(input => [input.name || 'message', input.value])), whatsappUrl: whatsappUrl() })); } catch (_) { /* Native form submission still proceeds. */ }
  };
  const restorePending = pending => {
    state.reference = pending.reference;
    state.tent = pending.tent;
    state.roofbars = pending.roofbars;
    state.roofbarsAnswered = pending.roofbarsAnswered ?? true;
    if (isMobile() && state.tent) state.mobileStage = 'roofbars';
    state.modalStep = 'extras';
    state.accessoryConfirmed = true;
    state.earlyAccessories = [...pending.accessories];
    state.previewDays = pending.previewDays;
    cards.accessories.querySelectorAll('[data-preview-accessory]').forEach(input => { input.checked = pending.accessories.includes(input.value); });
    form.querySelectorAll('[data-modal-accessory]').forEach(input => { input.checked = pending.accessories.includes(input.value); });
    for (const input of form.querySelectorAll('input:not([type="hidden"]), textarea')) {
      const key = input.name || (input.hasAttribute('data-rental-message') ? 'message' : '');
      if (!key || pending.fields[key] == null) continue;
      if (input.type === 'radio') input.checked = pending.fields[key] === input.value;
      else input.value = pending.fields[key];
    }
    render(); renderCalendar(); renderModalStep();
  };
  const renderModalStep = () => {
    const steps = { dates: ['Stap 1 van 3 · Reisdata', 'Kies je reisdata'], details: ['Stap 2 van 3 · Jouw gegevens', 'Jouw gegevens'], extras: ["Stap 3 van 3 · Extra's", "Kies je extra's"] };
    form.querySelector('[data-rental-dates-step]').hidden = state.modalStep !== 'dates';
    form.querySelector('[data-rental-details-step]').hidden = state.modalStep !== 'details';
    form.querySelector('[data-rental-extras-step]').hidden = state.modalStep !== 'extras';
    form.querySelector('[data-rental-final-actions]').hidden = state.modalStep !== 'extras';
    form.querySelector('[data-rental-step-indicator]').textContent = steps[state.modalStep][0];
    form.querySelector('#RentalAvailabilityTitle').textContent = steps[state.modalStep][1];
    form.querySelector('[data-rental-calendar-back]').textContent = state.modalStep === 'dates' ? '← TERUG' : '← VORIGE STAP';
    form.querySelector('[data-rental-extras-total]').textContent = duration(startInput.value, endInput.value) || !isMobile() ? euro(total(currentDays())) : '—';
    form.querySelector('.rental-availability__body').scrollTop = 0;
    queueDraftSave();
  };
  const showDetails = () => {
    if (!duration(startInput.value, endInput.value)) { feedback.textContent = 'Kies een geldige start- en einddatum.'; feedback.hidden = false; startInput.focus({ preventScroll: true }); return; }
    resetError(); state.modalStep = 'details'; renderModalStep();
    form.querySelector('[name="contact[Naam]"]').focus({ preventScroll: true });
  };
  const showExtras = () => {
    if (!duration(startInput.value, endInput.value)) { state.modalStep = 'dates'; renderModalStep(); showDetails(); return; }
    const fields = [...form.querySelectorAll('[data-rental-details-step] input[required]')];
    const invalid = fields.find(input => !input.checkValidity());
    if (invalid) { invalid.reportValidity(); invalid.focus(); return; }
    resetError(); state.modalStep = 'extras'; renderModalStep();
    form.querySelectorAll('[data-modal-accessory]').forEach(input => { input.checked = selectedAccessories().includes(input.value); });
    renderSummary(); (state.submissionPhase === 'uncertain' ? fallback : submit).focus({ preventScroll: true });
    publish('rental_extras_step_viewed', { days: duration(startInput.value, endInput.value) });
  };
  const open = trigger => {
    if (isMobile() && !state.tent) { switchMobileStage('tent', root.querySelector('[data-mobile-tent-select]')); scrollTo(funnel); return; }
    if (isMobile() && !state.roofbarsAnswered) { switchMobileStage('roofbars', root.querySelector('[data-mobile-roofbars-back]')); scrollTo(funnel); return; }
    if (!state.tent) { cta.focus(); return; }
    if (!state.accessoryConfirmed) { state.mobileStage = 'accessories'; render(); scrollTo(accessoryStage); accessoryStage.querySelector('[data-rental-accessory-continue]')?.focus({ preventScroll: true }); return; }
    state.returnFocus = trigger;
    state.open = true;
    preModalOffset = (isMobile() ? funnel : root.querySelector('.rental-pricing__grid')).getBoundingClientRect().top;
    backdrop.hidden = false;
    if (desktopView() && sidebar) sidebar.inert = true;
    document.dispatchEvent(new CustomEvent('daktenter:rental-modal-state', { detail: { open: true } }));
    state.bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    resetError(); renderSummary(); renderCalendar(); renderModalStep();
    dialog.focus({ preventScroll: true });
    publish('rental_availability_modal_opened', { tent_type: state.tent, days: state.previewDays });
    publish('rental_calendar_opened', { tent_type: state.tent });
    queueDraftSave();
  };
  const close = () => {
    if (!state.open) return;
    state.open = false;
    backdrop.hidden = true;
    if (sidebar) sidebar.inert = false;
    document.body.style.overflow = state.bodyOverflow;
    if (state.tent) {
      state.mobileStage = 'accessories';
      state.accessoryConfirmed = false;
      state.transitionTarget = '';
      state.transitioning = false;
      render();
      accessoryStage.querySelector('[data-rental-accessory-continue]')?.focus({ preventScroll: true });
      frame(() => {
        const headerBottom = document.querySelector('header-component')?.getBoundingClientRect().bottom || 0;
        const roofTop = accessoryStage.getBoundingClientRect().top;
        const summaryClearance = isMobile() ? root.querySelector('[data-mobile-tent-summary]').getBoundingClientRect().height : 0;
        const stageTop = headerBottom + 16 + summaryClearance;
        if (Math.abs(roofTop - stageTop) > 2) {
          window.scrollBy({ top: roofTop - stageTop, behavior: reduceMotion() ? 'instant' : 'smooth' });
        }
      });
    } else if (!state.submitting) {
      state.mobileStage = 'tent';
      render();
      root.querySelector('[data-mobile-tent-select]')?.focus({ preventScroll: true });
    } else state.returnFocus?.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('daktenter:rental-modal-state', { detail: { open: false } }));
    queueDraftSave();
  };
  const daysGrid = form.querySelector('[data-rental-days]');
  const monthTitle = form.querySelector('[data-rental-month-title]');
  const renderCalendar = () => {
    const year = state.month.getFullYear(), month = state.month.getMonth();
    const today = new Date();
    const todayIso = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    monthTitle.textContent = new Intl.DateTimeFormat('nl-NL', { month: 'long', year: 'numeric' }).format(state.month);
    const offset = (new Date(year, month, 1).getDay() + 6) % 7;
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    daysGrid.replaceChildren();
    for (let i = 0; i < offset; i++) { const space = document.createElement('span'); space.setAttribute('aria-hidden', 'true'); daysGrid.append(space); }
    for (let day = 1; day <= daysInMonth; day++) {
      const date = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = String(day); button.dataset.date = date;
      button.setAttribute('aria-label', new Intl.DateTimeFormat('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(year, month, day)));
      const edge = date === startInput.value || date === endInput.value;
      if (edge) { button.dataset.edge = date === startInput.value ? 'start' : 'end'; button.setAttribute('aria-pressed', 'true'); }
      if (startInput.value && endInput.value && date > startInput.value && date < endInput.value) button.dataset.inRange = 'true';
      if (date === todayIso) button.dataset.today = 'true';
      daysGrid.append(button);
    }
  };
  const chooseDate = date => {
    if (!startInput.value || endInput.value || date < startInput.value) { startInput.value = date; endInput.value = ''; }
    else endInput.value = date;
    endInput.min = startInput.value;
    renderCalendar(); renderSummary();
    publish('rental_dates_selected', { range_complete: Boolean(endInput.value), days: duration(startInput.value, endInput.value) || undefined });
  };

  // A short-lived same-tab draft is shared by ordinary resume and reload restore.
  // Browser scroll coordinates alone cannot reconstruct the selected funnel stage.
  const validIsoDate = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(new Date(`${value}T12:00:00`).getTime());
  const readDraft = () => {
    try {
      const draft = JSON.parse(readStorage(draftKey) || 'null');
      if (![1, 2].includes(draft?.version) || !Number.isFinite(draft.savedAt) || Date.now() - draft.savedAt > 600000 || draft.savedAt > Date.now()) return null;
      if (!['', 'lightweight', 'softtop', 'hardtop'].includes(draft.tent) || !['tent', 'roofbars', 'accessories', 'calendar'].includes(draft.mobileStage) || !['dates', 'details', 'extras'].includes(draft.modalStep)) return null;
      if (draft.start && !validIsoDate(draft.start) || draft.end && !validIsoDate(draft.end) || draft.end && (!draft.start || draft.end < draft.start)) return null;
      if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(draft.month) || !Array.isArray(draft.accessories) || !draft.accessories.every(value => ['awning', 'powerbank', 'bikecarrier'].includes(value))) return null;
      if (draft.version === 1) { draft.accessoryConfirmed = draft.open === true || draft.mobileStage === 'calendar'; draft.earlyAccessories = [...draft.accessories]; }
      if (!Array.isArray(draft.earlyAccessories) || !draft.earlyAccessories.every(value => accessoryKeys.includes(value))) return null;
      return draft;
    } catch (_) { return null; }
  };
  const persistDraft = () => {
    if (state.submissionPhase === 'confirmed') { removeStorage(draftKey); return; }
    if (!draftReady || restoring) return;
    const anchor = isMobile() ? funnel : root.querySelector('.rental-pricing__grid');
    const fields = Object.fromEntries([...form.querySelectorAll('input:not([type="hidden"]), textarea')]
      .filter(input => input.name?.startsWith('contact[') && (input.type !== 'radio' || input.checked))
      .map(input => [input.name, String(input.value).slice(0, 500)]));
    fields.message = form.querySelector('[data-rental-message]').value.slice(0, 500);
    const accessoryExpanded = [...accessoryStage.querySelectorAll('details[open]')].map(details => details.closest('[data-accessory-card]').dataset.accessoryCard);
    const expanded = [...root.querySelectorAll('.rental-pricing__disclosure > button')].map((button, index) => button.getAttribute('aria-expanded') === 'true' ? index : -1).filter(index => index !== -1);
    writeStorage(draftKey, JSON.stringify({
      version: 2, reference: state.reference, accessoryConfirmed: state.accessoryConfirmed, earlyAccessories: state.earlyAccessories, accessoryExpanded, accessoryLeft: accessoryStage.querySelector('.rental-pricing__accessory-track').scrollLeft, savedAt: Date.now(), working: draftWorking, open: state.open,
      tent: state.tent, mobileStage: state.open ? 'calendar' : state.transitionTarget || state.mobileStage, modalStep: state.modalStep,
      roofbars: state.roofbars, roofbarsAnswered: state.roofbarsAnswered,
      accessories: selectedAccessories(), previewDays: state.previewDays,
      start: startInput.value, end: endInput.value,
      month: `${state.month.getFullYear()}-${String(state.month.getMonth() + 1).padStart(2, '0')}`,
      fields, expanded, carouselLeft: carousel.scrollLeft,
      viewportOffset: state.open ? preModalOffset : anchor.getBoundingClientRect().top,
      modalScrollTop: form.querySelector('.rental-availability__body').scrollTop,
    }));
  };
  queueDraftSave = () => {
    if (!draftReady || restoring) return;
    window.clearTimeout(saveTimer);
    // An open booking step must survive even an immediate browser refresh.
    // The draft is small, so persist it in the current input/change task.
    if (state.open) persistDraft();
    else saveTimer = later(persistDraft, 120);
  };
  // A fast refresh can occur before the debounced save runs. Flush the current
  // form and funnel state while the page is still available to pagehide.
  listen(window, 'pagehide', () => {
    window.clearTimeout(saveTimer);
    persistDraft();
  });
  const restoreDraft = (draft, activeReload) => {
    restoring = true;
    state.reference ||= typeof draft.reference === 'string' ? draft.reference : '';
    state.tent = draft.tent;
    state.roofbars = draft.roofbars === true;
    state.roofbarsAnswered = draft.roofbarsAnswered === true;
    state.mobileStage = draft.mobileStage;
    state.modalStep = draft.modalStep;
    state.accessoryConfirmed = draft.accessoryConfirmed === true;
    state.earlyAccessories = [...draft.earlyAccessories];
    state.previewDays = Number.isSafeInteger(draft.previewDays) && draft.previewDays > 0 ? draft.previewDays : 1;
    state.month = new Date(`${draft.month}-01T12:00:00`);
    state.open = activeReload && draft.open === true && Boolean(draft.tent);
    draftWorking = activeReload && draft.working === true;
    preModalOffset = Number.isFinite(draft.viewportOffset) ? draft.viewportOffset : 72;
    startInput.value = draft.start || '';
    endInput.value = draft.end || '';
    endInput.min = startInput.value;
    const accessories = new Set(draft.accessories);
    root.querySelectorAll('[data-preview-accessory], [data-modal-accessory]').forEach(input => { input.checked = accessories.has(input.value); });
    if (draft.fields && typeof draft.fields === 'object') {
      form.querySelectorAll('input:not([type="hidden"]), textarea').forEach(input => {
        if (!input.name?.startsWith('contact[') || typeof draft.fields[input.name] !== 'string') return;
        if (input.type === 'radio') input.checked = draft.fields[input.name] === input.value;
        else input.value = draft.fields[input.name].slice(0, 500);
      });
    }
    if (typeof draft.fields?.message === 'string') form.querySelector('[data-rental-message]').value = draft.fields.message.slice(0, 500);
    accessoryStage.querySelectorAll('details').forEach(details => { details.open = draft.accessoryExpanded?.includes(details.closest('[data-accessory-card]').dataset.accessoryCard) || false; });
    accessoryStage.querySelector('.rental-pricing__accessory-track').scrollLeft = Math.max(0, Number(draft.accessoryLeft) || 0);
    root.querySelectorAll('.rental-pricing__disclosure > button').forEach((button, index) => {
      const expanded = Array.isArray(draft.expanded) && draft.expanded.includes(index);
      button.setAttribute('aria-expanded', String(expanded));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = !expanded;
    });
    render(); renderCalendar(); renderModalStep();
    carousel.scrollLeft = Math.max(0, Number(draft.carouselLeft) || 0);
    if (state.open) {
      backdrop.hidden = false;
      if (desktopView() && sidebar) sidebar.inert = true;
      // Hydration displays the saved step directly; entrance motion is for a new open.
      backdrop.style.animation = 'none';
      state.bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      document.dispatchEvent(new CustomEvent('daktenter:rental-modal-state', { detail: { open: true } }));
      form.querySelector('.rental-availability__body').scrollTop = Math.max(0, Number(draft.modalScrollTop) || 0);
      dialog.focus({ preventScroll: true });
      frame(() => { backdrop.style.animation = ''; });
    }
    if (activeReload) {
      const anchor = isMobile() ? funnel : root.querySelector('.rental-pricing__grid');
      const offset = Math.max(-innerHeight, Math.min(innerHeight, preModalOffset));
      window.scrollTo({ top: Math.max(0, window.scrollY + anchor.getBoundingClientRect().top - offset), behavior: 'instant' });
    }
    restoring = false;
  };

  const flyDesktopIdentity = async (source, destination) => {
    if (reduceMotion() || !desktopView() || !source || !destination) return;
    const from = source.getBoundingClientRect(), to = destination.getBoundingClientRect();
    if (!from.width || !to.width || !to.height) return;
    const ghost = document.createElement('div');
    ghost.className = 'rental-desktop-flight';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.inert = true;
    const image = source.cloneNode(false);
    image.alt = '';
    image.removeAttribute('loading');
    ghost.append(image);
    Object.assign(ghost.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px` });
    document.body.append(ghost);
    const animation = animate(ghost, [
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: `translate(${to.left - from.left}px, ${to.top - from.top}px) scale(${to.width / from.width}, ${to.height / from.height})`, opacity: 1 }
    ], { duration: 610, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'forwards' });
    const abort = () => animation.cancel();
    listen(window, 'resize', abort, { once: true });
    try { await animation.finished; } catch (_) { /* Resize leaves the correct state in place. */ }
    window.removeEventListener('resize', abort);
    ghost.remove();
  };
  const desktopTentCommit = async (button) => {
    if (state.transitioning) return;
    state.transitioning = true;
    const chosen = cards[state.tent];
    root.querySelectorAll('.rental-pricing__disclosure > button[aria-expanded="true"]').forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      document.getElementById(toggle.getAttribute('aria-controls')).hidden = true;
    });
    await new Promise(resolve => frame(resolve));
    const headerHeight = document.querySelector('header-component')?.getBoundingClientRect().height || 90;
    const cardOffset = chosen.getBoundingClientRect().top - headerHeight - 16;
    if (Math.abs(cardOffset) > 24) {
      window.scrollBy({ top: cardOffset, behavior: reduceMotion() ? 'instant' : 'smooth' });
      if (!reduceMotion()) await new Promise(resolve => later(resolve, 340));
    }
    const carouselScroll = carousel.scrollLeft;
    const destination = sidebar.querySelector('[data-rental-sidebar-tent]');
    destination.classList.add('is-arriving');
    state.mobileStage = 'roofbars';
    render();
    carousel.scrollLeft = carouselScroll;
    placeDesktopRoofCard();
    roofStage.classList.add('is-entering');
    await flyDesktopIdentity(chosen.querySelector('.rental-pricing__media img'), destination.querySelector('[data-rental-sidebar-thumbnail]'));
    destination.classList.remove('is-arriving');
    roofStage.classList.remove('is-entering');
    state.transitioning = false;
    roofStage.querySelector('[data-mobile-roofbars-answer]')?.focus({ preventScroll: true });
    root.querySelector('[data-mobile-step-status]').textContent = 'Stap 2: kies dakdragers.';
    queueDraftSave();
  };
  const desktopRoofChoice = async (button) => {
    if (state.transitioning) return;
    state.transitioning = true;
    state.roofbars = button.dataset.mobileRoofbarsAnswer === 'yes';
    state.roofbarsAnswered = true;
    publish('rental_roofbars_answered', { selected: state.roofbars });
    const destination = sidebar.querySelector('[data-rental-sidebar-roof]');
    destination.classList.add('is-arriving');
    render();
    if (state.roofbars) await flyDesktopIdentity(roofStage.querySelector('.rental-pricing__mobile-roofbars-media img'), destination.querySelector('[data-rental-sidebar-roof-thumbnail]'));
    destination.classList.remove('is-arriving');
    state.mobileStage = 'accessories';
    state.accessoryConfirmed = false;
    state.transitioning = false;
    render();
    root.querySelector('[data-mobile-step-status]').textContent = 'Kies je accessoires.';
    scrollTo(accessoryStage);
    accessoryStage.querySelector('[data-rental-accessory-continue]')?.focus({ preventScroll: true });
  };

  for (const [key, card] of Object.entries(cards)) {
    listen(card.querySelector('[data-preview-select]'), 'click', () => {
      if (key === 'roofbars') { state.roofbars = !state.roofbars; state.roofbarsAnswered = true; publish('rental_roofbars_selected', { selected: state.roofbars }); }
      else if (key === 'lightweight' || key === 'softtop' || key === 'hardtop') { const previous = state.tent; state.tent = state.tent === key ? '' : key; publish(previous && previous !== key ? 'rental_tent_changed' : 'rental_tent_selected', { model: key, selected: state.tent === key, preview_days: isMobile() ? undefined : state.previewDays }); }
      render();
    });
    if (key !== 'accessories') listen(card, 'click', event => {
      if (!event.target.closest('button, input, label, a, details, summary')) card.querySelector('[data-preview-select]').click();
    });
    card.querySelectorAll('[data-day-step]').forEach(button => listen(button, 'click', () => {
      const next = Math.max(1, state.previewDays + Number(button.dataset.dayStep));
      if (next === state.previewDays || !Number.isSafeInteger(next)) return;
      state.previewDays = next; render();
      publish('rental_preview_days_changed', { item: key, preview_days: next });
    }));
    card.querySelectorAll('[data-preview-accessory]').forEach(input => listen(input, 'change', () => {
      render(); publish('rental_accessory_selected', { accessory: input.value, selected: input.checked, preview_days: state.previewDays });
    }));
  }
  let committingTent = false;
  root.querySelectorAll('[data-mobile-tent-select]').forEach(button => listen(button, 'click', async () => {
    if (committingTent || state.transitioning) return;
    committingTent = true;
    const previous = state.tent;
    state.tent = button.dataset.mobileTentSelect;
    publish(previous && previous !== state.tent ? 'rental_tent_changed' : 'rental_tent_selected', { model: state.tent, selected: true });
    render();
    if (desktopView()) { await desktopTentCommit(button); committingTent = false; return; }
    const selectedCard = cards[state.tent];
    const openDisclosures = [...root.querySelectorAll('.rental-pricing__disclosure > button[aria-expanded="true"]')];
    const expandedPanelHeight = openDisclosures.filter(toggle => selectedCard.contains(toggle)).reduce((height, toggle) => height + (document.getElementById(toggle.getAttribute('aria-controls'))?.getBoundingClientRect().height || 0), 0);
    funnel.style.setProperty('--rental-closed-card-height', `${Math.max(0, selectedCard.getBoundingClientRect().height - expandedPanelHeight)}px`);
    const offset = selectedCard.getBoundingClientRect().top - 72;
    if (Math.abs(offset) > 24) {
      window.scrollBy({ top: offset, behavior: reduceMotion() ? 'instant' : 'smooth' });
      if (!reduceMotion()) await new Promise(resolve => later(resolve, 300));
    }
    switchMobileStage('roofbars', root.querySelector('[data-mobile-roofbars-back]'));
    openDisclosures.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
    committingTent = false;
  }));
  root.querySelectorAll('.rental-pricing__disclosure > button').forEach(button => listen(button, 'click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    document.getElementById(button.getAttribute('aria-controls')).hidden = expanded;
  }));
  const returnToTents = () => {
    if (desktopView()) {
      state.mobileStage = 'tent'; state.roofbarsAnswered = false; render();
      cards[state.tent || 'lightweight'].querySelector('[data-preview-select]')?.focus({ preventScroll: true });
      return;
    }
    switchMobileStage('tent', root.querySelector(`[data-mobile-tent-select="${state.tent || 'lightweight'}"]`));
  };
  listen(root.querySelector('[data-mobile-roofbars-back]'), 'click', returnToTents);
  listen(root.querySelector('[data-mobile-tent-change]'), 'click', returnToTents);
  listen(root.querySelector('[data-mobile-roof-change]'), 'click', () => { state.mobileStage = 'roofbars'; if (desktopView()) state.roofbarsAnswered = false; render(); roofStage.querySelector('[data-mobile-roofbars-answer]')?.focus({ preventScroll: true }); });
  root.querySelectorAll('[data-mobile-roofbars-answer]').forEach(button => listen(button, 'click', () => {
    if (desktopView()) { desktopRoofChoice(button); return; }
    if (state.transitioning) return;
    state.transitioning = true;
    state.transitionTarget = 'accessories';
    state.roofbars = button.dataset.mobileRoofbarsAnswer === 'yes'; state.roofbarsAnswered = true;
    render(); publish('rental_roofbars_answered', { selected: state.roofbars });
    if (reduceMotion()) { state.mobileStage = 'accessories'; state.accessoryConfirmed = false; state.transitioning = false; state.transitionTarget = ''; render(); accessoryStage.querySelector('[data-rental-accessory-continue]')?.focus({ preventScroll: true }); return; }
    const card = roofStage.querySelector('[data-mobile-roofbars]');
    const summary = root.querySelector('[data-mobile-roof-summary]');
    summary.hidden = false;
    const summaryAnimation = animate(summary, [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 590, easing: 'cubic-bezier(.22,.8,.28,1)', fill: 'forwards' });
    const animation = animate(card, [{ transform: 'scaleY(1)', opacity: 1 }, { transform: 'scaleY(.22)', opacity: .08 }], { duration: 590, easing: 'cubic-bezier(.22,.8,.28,1)', fill: 'forwards' });
    animation.finished.then(() => { if (controller.signal.aborted) return; animation.cancel(); summaryAnimation.cancel(); state.mobileStage = 'accessories'; state.accessoryConfirmed = false; state.transitioning = false; state.transitionTarget = ''; render(); accessoryStage.querySelector('[data-rental-accessory-continue]')?.focus({ preventScroll: true }); root.querySelector('[data-mobile-step-status]').textContent = 'Kies je accessoires.'; }).catch(() => {});
  }));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (isMobile() && !state.carouselViewed && entries.some(entry => entry.isIntersecting)) {
        state.carouselViewed = true; publish('rental_mobile_tent_carousel_view'); observer.disconnect();
      }
    }, { threshold: .35 });
    resources.push(() => observer.disconnect());
    observer.observe(carousel);
  }
  listen(form.querySelector('[data-rental-dates-next]'), 'click', showDetails);
  listen(form.querySelector('[data-rental-next]'), 'click', showExtras);
  listen(form.querySelector('[data-rental-calendar-back]'), 'click', () => {
    if (state.modalStep === 'extras') { state.modalStep = 'details'; renderModalStep(); dialog.focus({ preventScroll: true }); return; }
    if (state.modalStep === 'details') { state.modalStep = 'dates'; renderModalStep(); dialog.focus({ preventScroll: true }); return; }
    close();
  });
  listen(form.querySelector('[data-rental-no-extras]'), 'click', () => {
    // Last-chance skip never clears selections made earlier.
    render(); form.querySelector('[data-rental-submit]').focus({ preventScroll: true });
  });
  form.querySelectorAll('[data-modal-accessory]').forEach(input => listen(input, 'change', () => {
    const source = cards.accessories.querySelector(`[data-preview-accessory][value="${input.value}"]`);
    source.checked = input.checked; render();
    if (input.checked) form.querySelector(`[data-rental-remove-accessory="${input.value}"]`)?.focus({ preventScroll: true });
    publish('rental_accessory_selected', { accessory: input.value, selected: input.checked, days: duration(startInput.value, endInput.value) });
  }));
  const removeAccessory = event => {
    const button = event.target.closest('[data-rental-remove-accessory]');
    if (!button) return;
    const key = button.dataset.rentalRemoveAccessory;
    cards.accessories.querySelector(`[data-preview-accessory][value="${key}"]`).checked = false;
    state.earlyAccessories = state.earlyAccessories.filter(value => value !== key);
    render();
    const offer = form.querySelector(`[data-modal-accessory][value="${key}"]`);
    if (state.open && state.modalStep === 'extras') offer?.focus({ preventScroll: true });
    else sidebar?.querySelector('[data-rental-sidebar-cta]')?.focus({ preventScroll: true });
    publish('rental_accessory_selected', { accessory: key, selected: false });
  };
  listen(form.querySelector('[data-rental-final-lines]'), 'click', removeAccessory);
  listen(sidebar, 'click', removeAccessory);
  accessoryStage.querySelectorAll('[data-rental-accessory-toggle]').forEach(button => listen(button, 'click', () => {
    const source = cards.accessories.querySelector(`[data-preview-accessory][value="${button.dataset.rentalAccessoryToggle}"]`);
    source.checked = !source.checked;
    render();
    publish('rental_accessory_selected', { accessory: source.value, selected: source.checked });
  }));
  listen(accessoryStage.querySelector('[data-rental-accessory-back]'), 'click', () => { state.mobileStage = 'roofbars'; render(); roofStage.querySelector('[data-mobile-roofbars-answer]')?.focus({ preventScroll: true }); });
  const continueAccessories = trigger => {
    state.earlyAccessories = [...selectedAccessories()];
    state.accessoryConfirmed = true;
    state.mobileStage = 'calendar';
    state.modalStep = 'dates';
    render(); open(trigger);
  };
  listen(accessoryStage.querySelector('[data-rental-accessory-continue]'), 'click', event => continueAccessories(event.currentTarget));
  // Skipping this decision must not erase work already present in the draft.
  listen(accessoryStage.querySelector('[data-rental-accessory-none]'), 'click', event => continueAccessories(event.currentTarget));
  document.querySelectorAll('[data-rental-open]').forEach(trigger => listen(trigger, 'click', () => open(trigger)));
  if (sidebar) {
    listen(sidebar.querySelector('[data-rental-sidebar-cta]'), 'click', event => {
      if (state.mobileStage === 'tent' || !state.tent) {
        scrollTo(funnel);
        root.querySelector(`[data-mobile-tent-select="${state.tent || 'lightweight'}"]`)?.focus({ preventScroll: true });
      } else if (state.mobileStage === 'roofbars' || !state.roofbarsAnswered) {
        scrollTo(funnel);
        roofStage.querySelector('[data-mobile-roofbars-answer]')?.focus({ preventScroll: true });
      } else if (state.mobileStage === 'accessories') {
        continueAccessories(event.currentTarget);
      } else open(event.currentTarget);
    });
    listen(sidebar.querySelector('[data-rental-sidebar-edit-tent]'), 'click', () => { returnToTents(); scrollTo(funnel); });
    listen(sidebar.querySelector('[data-rental-sidebar-edit-roof]'), 'click', () => {
      state.mobileStage = 'roofbars'; state.roofbarsAnswered = false; render(); scrollTo(funnel);
      roofStage.querySelector('[data-mobile-roofbars-answer]')?.focus({ preventScroll: true });
    });
  }
  document.querySelectorAll('a[href*="wa.me/"]').forEach(trigger => {
    if (trigger.textContent.trim().toUpperCase() !== 'CONTROLEER BESCHIKBAARHEID') return;
    listen(trigger, 'click', event => { if (isMobile()) { event.preventDefault(); open(trigger); } });
  });
  listen(window, 'resize', () => { render(); scheduleRailPosition(); });
  listen(form.querySelector('[data-rental-close]'), 'click', close);
  listen(backdrop, 'click', event => { if (event.target === backdrop) close(); });
  form.querySelectorAll('[data-rental-month-step]').forEach(button => listen(button, 'click', () => {
    state.month.setMonth(state.month.getMonth() + Number(button.dataset.rentalMonthStep)); renderCalendar();
  }));
  listen(daysGrid, 'click', event => { const button = event.target.closest('button[data-date]'); if (button) chooseDate(button.dataset.date); });
  listen(daysGrid, 'keydown', event => {
    const button = event.target.closest('button[data-date]'); if (!button) return;
    const step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[event.key];
    if (!step) return;
    event.preventDefault();
    const next = new Date(`${button.dataset.date}T12:00:00`); next.setDate(next.getDate() + step);
    state.month = new Date(next.getFullYear(), next.getMonth(), 1); renderCalendar();
    daysGrid.querySelector(`[data-date="${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, '0')}-${String(next.getDate()).padStart(2, '0')}"]`)?.focus();
  });
  listen(startInput, 'change', () => { if (endInput.value < startInput.value) endInput.value = ''; endInput.min = startInput.value; if (startInput.value) state.month = new Date(`${startInput.value}T12:00:00`); renderCalendar(); renderSummary(); });
  listen(endInput, 'change', () => { if (endInput.value) state.month = new Date(`${endInput.value}T12:00:00`); renderCalendar(); renderSummary(); });
  form.querySelectorAll('[name="contact[Vertrek]"]').forEach(input => listen(input, 'change', () => { renderSummary(); publish('rental_fulfilment_selected', { fulfilment_type: input.value.toLowerCase() }); }));
  form.querySelectorAll('[data-rental-vehicle-field]').forEach(input => listen(input, 'change', () => {
    if (!state.vehicleCompleted && [...form.querySelectorAll('[data-rental-vehicle-field]')].every(field => field.value.trim())) { state.vehicleCompleted = true; publish('rental_vehicle_fields_completed', { roof_bars: state.roofbars }); }
  }));
  listen(document, 'keydown', event => {
    if (!state.open) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), a[href], summary')].filter(el => el.getClientRects().length);
    if (!focusable.length) { event.preventDefault(); dialog.focus(); return; }
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
  });
  listen(retry, 'click', () => { if (state.submissionPhase !== 'failed') return; resetError(); submit.click(); });
  listen(fallback, 'click', () => publish('rental_whatsapp_opened', { registered: false }));
  listen(form, 'submit', event => {
    const block = () => { event.preventDefault(); event.stopImmediatePropagation(); };
    // Capture runs before Shopify's bubble handler (which ignores defaultPrevented).
    // Shopify resolves the first token by calling captured native submit directly;
    // there is no legitimate second submit event to exempt based on token contents.
    if (submissionBlocked()) { block(); checkSubmissionDeadline(); return; }
    if (state.modalStep !== 'extras') { block(); state.modalStep === 'dates' ? showDetails() : showExtras(); return; }
    if (!state.tent || !duration(startInput.value, endInput.value)) { block(); setError('Kies een daktent en twee geldige reisdata.'); return; }
    if (!form.reportValidity()) { block(); return; }
    state.reference ||= createReference();
    state.submissionPhase = 'pending'; state.submissionDeadline = Date.now() + 30000;
    fillSubmission(); persistPending(); persistDraft();
    state.submitting = true; submit.disabled = true; submit.hidden = false;
    resetError();
    submit.setAttribute('aria-busy', 'true');
    const dots = document.createElement('span');
    dots.className = 'rental-availability__feedback-dots';
    dots.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 3; i++) dots.append(document.createElement('i'));
    feedback.replaceChildren(document.createTextNode('AANVRAAG WORDT GEREGISTREERD'), dots);
    feedback.classList.add('is-registering'); feedback.hidden = false;
    publish('rental_request_submitted', { tent_type: state.tent, days: duration(startInput.value, endInput.value), roof_bars: state.roofbars, awning: selectedAccessories().includes('awning'), powerbank: selectedAccessories().includes('powerbank'), bikecarrier: selectedAccessories().includes('bikecarrier'), total: total(currentDays()) });
    later(checkSubmissionDeadline, 30000);
  }, { capture: true });
  const showRegistered = () => {
    state.submissionPhase = 'confirmed'; state.submitting = false;
    submit.disabled = true; submit.hidden = true;
    close();
    removeStorage(draftKey);
    const message = root.querySelector('[data-rental-registered]');
    message.hidden = false;
    message.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    later(() => { message.hidden = true; }, 6500);
  };
  // Theme Editor re-renders must never replay registration or an external handoff.
  const allowReturnEffects = !window.Shopify?.designMode && !editorReinitializing;
  const pending = (() => { try { const value = JSON.parse(readStorage(storageKey) || 'null'); return typeof value?.reference === 'string' && Number.isFinite(value.savedAt) ? value : null; } catch (_) { return null; } })();
  const wasHandoff = allowReturnEffects ? readStorage(handoffKey) : null;
  const draft = !wasHandoff ? readDraft() : null;
  const reloadMode = document.documentElement.dataset.rentalReload;
  let returnFailed = false;
  if (wasHandoff) {
    removeStorage(handoffKey); removeStorage(storageKey);
    showRegistered();
  } else if (pending) {
    state.reference = pending.reference;
    // Restore the original attempt only within the existing personal-data TTL.
    // A newer valid draft remains authoritative for edited fields/selections.
    if (Date.now() - pending.savedAt < 600000 && pending.fields && Array.isArray(pending.accessories)) restorePending(pending);
    const params = new URLSearchParams(location.search);
    const registered = allowReturnEffects && !form.querySelector('.errors') && (form.querySelector('[data-rental-server-success]') || params.get('contact_posted') === 'true');
    if (registered) {
      state.submissionPhase = 'confirmed';
      writeStorage(handoffKey, pending.reference);
      params.delete('contact_posted'); history.replaceState(history.state, '', `${location.pathname}${params.size ? `?${params}` : ''}${location.hash}`);
      publish('rental_request_registered', { tent_type: state.tent, days: duration(startInput.value, endInput.value), total: total(currentDays()) });
      publish('rental_whatsapp_opened', { registered: true });
      // The original submitted payload owns the confirmed handoff, not later edits.
      if (pending.whatsappUrl) location.assign(pending.whatsappUrl);
      else showRegistered();
    } else {
      // Only an explicit server rejection in a new document permits native retry.
      // Back/refresh, invisible CAPTCHA rejection and network silence are uncertain.
      returnFailed = allowReturnEffects && Boolean(form.querySelector('.errors'));
      state.submissionPhase = returnFailed ? 'failed' : 'uncertain';
      state.submissionDeadline = Number(pending.submissionDeadline) || pending.savedAt + 30000;
      saveSubmissionOutcome();
    }
  }
  listen(window, 'pageshow', event => {
    if (allowReturnEffects && event.persisted && readStorage(handoffKey)) { removeStorage(handoffKey); removeStorage(storageKey); showRegistered(); }
  });
  if (draft && state.submissionPhase !== 'confirmed') restoreDraft(draft, reloadMode === 'active' || editorReinitializing);
  else { render(); renderCalendar(); }
  if (returnFailed) { state.modalStep = 'extras'; state.accessoryConfirmed = true; open(cta); setError(submissionCopy.failed); }
  else showSubmissionRecovery();
  if (reloadMode === 'top' && !editorReinitializing) window.scrollTo({ top: 0, behavior: 'instant' });
  draftReady = true;
  if (draft) queueDraftSave();
  listen(root, 'click', queueDraftSave);
  listen(root, 'change', queueDraftSave);
  listen(form, 'input', queueDraftSave);
  listen(form.querySelector('.rental-availability__body'), 'scroll', queueDraftSave, { passive: true });
  listen(carousel, 'scroll', () => { placeDesktopRoofCard(); queueDraftSave(); }, { passive: true });
  const activeArea = isMobile() ? funnel : root.querySelector('.rental-pricing__grid');
  if ('IntersectionObserver' in window) {
    const workingObserver = new IntersectionObserver(entries => {
      draftWorking = entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0);
      queueDraftSave();
    }, { threshold: [0, .01], rootMargin: '-72px 0px -12% 0px' });
    workingObserver.observe(activeArea); resources.push(() => workingObserver.disconnect());
  }
  listen(window, 'pagehide', persistDraft);
  if (oldZone) { oldZone.hidden = true; oldZone.inert = true; }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { publish('rental_pricing_view'); observer.disconnect(); } }, { threshold: .2 });
    observer.observe(root); resources.push(() => observer.disconnect());
  } else publish('rental_pricing_view');
  disposePricing = () => {
    persistDraft();
    controller.abort();
    resources.reverse().forEach(dispose => dispose());
    delete root.dataset.initialized;
    if (state.open) document.body.style.overflow = state.bodyOverflow || '';
  };
  };
  initialize();
  if (typeof document !== 'undefined' && document.addEventListener) {
    document.addEventListener('shopify:section:unload', () => { editorReinitializing = true; disposePricing(); disposePricing = () => {}; });
    document.addEventListener('shopify:section:load', () => { editorReinitializing = true; initialize(); editorReinitializing = false; });
  }
})();
